import * as angular from "angular";
import * as moment from "moment";
import "./videoEvidence.scss";

import { IFilterModel } from "@directives/_resourceFilters/IFilterModel";
import { CameraDisplayService } from "../cameraDisplay.service";
import { VideoStatus } from "../enums/VideoStatus";
import { IVideoEntry } from "../models/IVideoEntry";
import { VideoEntryService } from "../services/video-entry.service";

interface IComponentBindings {
    filterModel: IFilterModel;
}

class ComponentController implements angular.IComponentController, IComponentBindings {
    loading: boolean;

    videos: IVideoEntry[] = [];

    filterModel: IFilterModel;

    static $inject = ["cameraDisplayService", "videoEntryService"];

    constructor(
        private readonly cameraDisplayService: CameraDisplayService,
        private readonly videoEntryService: VideoEntryService) {
    }
    
    $onInit() {
        this.getVideos();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj["filterModel"]) {
            this.getVideos();
        }
    }

    playVideo(video: IVideoEntry, $event: MouseEvent) {
        this.cameraDisplayService.showVideoPlayer(video, $event);
    }

    // ---

    private getVideos(): Promise<void> {

        this.loading = true;
        if (!this.filterModel) {
            this.filterModel = {
                start: moment().subtract(14, "days").toDate(),
                end: moment().toDate()
            };
        }

        return this.videoEntryService.getVideosEntriesWithMappings(this.filterModel.start, this.filterModel.end)
            .then(videos => {
                this.videos = videos;
                this.loading = false;
            });
    }

    onlyActiveVideos(video: IVideoEntry): boolean {
        return video.Status === VideoStatus.Downloaded;
    }
}

export class VideoEvidenceComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            filterModel: "<?"
        };

        this.controller = ComponentController;
        this.template = require("./videoEvidence.html");
    }
}
